let reduxStore;
/**
 * Registers the configured Redux store so non-React callers (e.g. sagas) can
 * read state and dispatch without a hook. Set once during store creation.
 */
export const setReduxStore = (store) => {
    reduxStore = store;
};
export const getReduxStore = () => {
    if (!reduxStore) {
        throw new Error('Redux store accessed before it was initialised');
    }
    return reduxStore;
};
